export default "__VITE_ASSET__G6r1f1D$__"